export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/logo-marquee.ae888672-a25611.png";